import { chargeCenterRoute } from '@/modules/charge-center/route';
import { createRoute } from '@tanstack/react-router';
import z from 'zod';

const drawerSearchSchema = z.object({
  connector: z.number().optional(),
  chargepoint: z.number().optional(),
});

export const gridConnectionsRoute = createRoute({
  getParentRoute: () => chargeCenterRoute,
  path: 'grid-connections',
  validateSearch: drawerSearchSchema,
});
